import React from 'react';
import type { AIChatMode } from './types';
import { Button } from '../button';
import { AIChatModeToggle } from './AIChatModeToggle';
import { HeaderContainer, HeaderTitleRow, HeaderTitle } from './AIChat.Styled';

export type AIChatHeaderProps = {
	title: string;
	onClose?: () => void;
	modes?: AIChatMode[];
	activeModeId?: string;
	onModeChange?: (modeId: string) => void;
};

export function AIChatHeader({
	title,
	onClose,
	modes,
	activeModeId,
	onModeChange,
}: AIChatHeaderProps): React.ReactElement {
	const showModeToggle = modes && modes.length > 1;

	return (
		<HeaderContainer>
			<HeaderTitleRow>
				<HeaderTitle>{title}</HeaderTitle>
				{onClose && (
					<Button
						variant="ghost"
						icon="x"
						size="small"
						onClick={onClose}
						aria-label="Close chat"
					/>
				)}
			</HeaderTitleRow>
			{showModeToggle && (
				<AIChatModeToggle
					modes={modes}
					activeModeId={activeModeId}
					onModeChange={onModeChange}
				/>
			)}
		</HeaderContainer>
	);
}
